import React, { CSSProperties, ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { AnimatePresence, motion, MotionProps } from 'framer-motion';
import { Checkbox } from '../Checkbox';
import { Radio } from '../Radio';
import { Tag } from '../Tag';
import { Text } from '../Text';
export type ControlType = 'radio' | 'checkbox';
interface Props {
  selected: boolean;
  dataId?: string;
  name: string;
  onChange: () => void;
  value?: string;
  children?: ReactNode;
  labelText?: string;
  withControlButton?: boolean;
  withBorder?: boolean;
  disabled?: boolean;
  className?: string;
  variant: ControlType;
  style?: CSSProperties;
  prefix?: ReactNode;
  title?: ReactNode;
  isVertical?: boolean;
  hasCheckmarkError?: boolean;
  hideDefaultControlButton?: boolean;
  motionWrapperProps?: Pick<MotionProps, 'initial' | 'animate' | 'exit' | 'transition' | 'variants'> & {
    key?: string;
  };
  expandableContent?: ReactNode;
}
const PrefixWrapper = /*#__PURE__*/styled('div')({
  name: "PrefixWrapper",
  class: "py9ywn5",
  propsAsIs: false
});
const TitleWrapper = /*#__PURE__*/styled('div')({
  name: "TitleWrapper",
  class: "t1b0gvnw",
  propsAsIs: false
});
const ContentContainer = /*#__PURE__*/styled('div')({
  name: "ContentContainer",
  class: "c1ob8uhu",
  propsAsIs: false
});
const Wrapper = /*#__PURE__*/styled('label')({
  name: "Wrapper",
  class: "wcgvokr",
  propsAsIs: false
});
const ControlButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ControlButtonWrapper",
  class: "clcispl",
  propsAsIs: false
});
const SelectionCardBody = /*#__PURE__*/styled('div')({
  name: "SelectionCardBody",
  class: "siloi5s",
  propsAsIs: false
});
const _exp32 = /*#__PURE__*/() => Tag;
const LabelText = /*#__PURE__*/styled(_exp32())({
  name: "LabelText",
  class: "l1llr0ch",
  propsAsIs: true
});
const _exp37 = /*#__PURE__*/() => motion.div;
const MotionWrapper = /*#__PURE__*/styled(_exp37())({
  name: "MotionWrapper",
  class: "mhgglft",
  propsAsIs: true
});
export const SelectionCard = ({
  selected,
  dataId = 'SelectionCard',
  name,
  onChange,
  value,
  children,
  labelText,
  withControlButton = true,
  withBorder = true,
  disabled = false,
  className,
  variant = 'radio',
  style,
  prefix,
  title,
  isVertical = false,
  hasCheckmarkError,
  motionWrapperProps,
  expandableContent,
  hideDefaultControlButton = false
}: Props) => {
  return <Wrapper className={cx(withBorder && 'withBorder', selected && 'isSelected', disabled && 'isDisabled', className)} onClick={withControlButton ? undefined : onChange} data-id={dataId} style={style}>
      {labelText && <LabelText variant={disabled ? 'neutral' : 'info'} className={cx(selected && !disabled && 'isSelected', 'tagLabelContainer')}>
          <Text variant="labelXS">{labelText}</Text>
        </LabelText>}

      <SelectionCardBody className={cx(isVertical && `--vertical`, withControlButton && `--with-control-button`)}>
        {Boolean(prefix) && <PrefixWrapper>{prefix}</PrefixWrapper>}
        {Boolean(title) && <TitleWrapper>
            <Text variant="bodyS">{title}</Text>
          </TitleWrapper>}
        {Boolean(children) && <ContentContainer>{children}</ContentContainer>}
        {withControlButton && <ControlButtonWrapper className={cx(!selected && hideDefaultControlButton && '--hide-default-control-button')}>
            {variant === 'checkbox' ? <Checkbox checked={selected} onChange={onChange} disabled={disabled} hasError={hasCheckmarkError} name={name} value={value} /> : <Radio checked={selected} onChange={onChange} disabled={disabled} name={name} value={value} />}
          </ControlButtonWrapper>}
      </SelectionCardBody>

      <AnimatePresence initial={false}>
        {selected && expandableContent && !disabled && <MotionWrapper {...motionWrapperProps}>
            {expandableContent}
          </MotionWrapper>}
      </AnimatePresence>
    </Wrapper>;
};

require("./SelectionCard.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SelectionCard.tsx");